import {
    JOBLEVELS_FETCHING,
    JOBLEVELS_FAILED,
    JOBLEVELS_SUCCESS
} from "../actions/types";

const initialState = {
    result: null,
    isFetching:false,
    isError: false
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case JOBLEVELS_FETCHING:
            return { ...state, result: null, isFetching: true, isError: false };
        case JOBLEVELS_FAILED:
            return { ...state, result: null, isFetching: false, isError: true };
        case JOBLEVELS_SUCCESS:
            return { ...state, result: payload, isFetching: false, isError: false };
        default:
            return state;
    }
};
